import { api } from './baseApi';
export var togetherActivityApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getTogetherActivitiesAdmin: builder.query({
                query: function () {
                    return ({
                        url: '/together-activities',
                        method: 'GET',
                    });
                },
                providesTags: ['TogetherActivities'],
            }),
            createTogetherActivity: builder.mutation({
                query: function (body) {
                    return ({
                        url: '/together-activities',
                        method: 'POST',
                        body: body,
                    });
                },
                invalidatesTags: ['TogetherActivities'],
            }),
            updateTogetherActivity: builder.mutation({
                query: function (_a) {
                    var id = _a.id, data = _a.data;
                    return ({
                        url: "/together-activities/".concat(id),
                        method: 'PUT',
                        body: data,
                    });
                },
                invalidatesTags: ['TogetherActivities'],
            }),
            deleteTogetherActivity: builder.mutation({
                query: function (id) {
                    return ({
                        url: "/together-activities/".concat(id),
                        method: 'DELETE',
                    });
                },
                invalidatesTags: ['TogetherActivities'],
            }),
        });
    },
});
export var useGetTogetherActivitiesAdminQuery = togetherActivityApi.useGetTogetherActivitiesAdminQuery, useCreateTogetherActivityMutation = togetherActivityApi.useCreateTogetherActivityMutation, useUpdateTogetherActivityMutation = togetherActivityApi.useUpdateTogetherActivityMutation, useDeleteTogetherActivityMutation = togetherActivityApi.useDeleteTogetherActivityMutation;
